// extracted by mini-css-extract-plugin
export var actionButton = "_y9-2";
export var card = "_y9-0";
export var disambiguationList = "_y9-3";
export var errorCard = "_y9-4";
export var row = "_y9-1";